import React from 'react';
import { IconProps } from './types';

const ArrowDown: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4.38618L2.50221 3L6 6.22763L9.49779 3L11 4.38618L6 9L1 4.38618Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default ArrowDown;
